import React from "react";
import { Stack, Grid, Box, CardContent } from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../../wrapper/wrapper";
import {
  CardBody,
  CardIcon,
  CardSubtitle,
  CardTitle,
  GetStartedButton,
  Subtitle,
  Title,
} from "./hero.components";
import HeroImage from "../../../images/homepage/hero.png";
import HeroBackground1 from "../../../images/homepage/hero-bg.png";
import HeroBackground2 from "../../../images/homepage/hero-bg-2.png";
import aboutContentData from "./cardAboutContents";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { internshipLink } from "../../../common/routes";

import "./hero.css";

function Hero() {
  return (
    <OuterWrapper sx={{ bgcolor: "#F8FBFE" }}>
      <OuterWrapper
        sx={{
          backgroundImage: { md: `url(${HeroBackground1})` },
          backgroundRepeat: "no-repeat",
          backgroundSize: "320px",
          position: "relative",
          backgroundPosition: "right",
          pt: "50px",
        }}
      >
        <InnerWrapper>
          <Grid container columns={16}>
            <Grid
              item
              xs={15}
              md={7}
              sx={{ px: { xs: "10px" }, pt: { xs: "50", md: "150px" } }}
            >
              <Title
                sx={{
                  fontSize: { xs: "37px", sm: "50px" },
                  lineHeight: { xs: "45px", md: "61px" },
                  mb: 2.5,
                }}
              >
                Learn while you <br /> Implement
              </Title>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2.5}
                sx={{ height: "100%", display: { xs: "none", md: "flex" } }}
              >
                <Subtitle>
                  Learn the required skills and get industry exposure to be
                  successful in your field and unlock new opportunities! Update
                  yourself with latest learning trends and get ready with
                  industry level projects.
                </Subtitle>
                <GetStartedButton component={Link} to={internshipLink}>
                  Get Started
                </GetStartedButton>
              </Stack>
            </Grid>
            <Grid item md={2} />
            <Grid item xs={15} md={7} pl={1.5}>
              <Box
                component="img"
                src={HeroImage}
                alt=""
                sx={{
                  width: { xs: "100%", sm: "525px" },
                }}
              />
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2.5}
                sx={{ height: "100%", display: { xs: "flex", md: "none" } }}
              >
                <Subtitle>
                  Learn the required skills and get industry exposure to be
                  successful in your field and unlock new opportunities! Update
                  yourself with latest learning trends and get ready with
                  industry level projects.
                </Subtitle>
                <GetStartedButton component={Link} to={internshipLink}>
                  Get Started
                </GetStartedButton>
              </Stack>
            </Grid>
          </Grid>
        </InnerWrapper>
      </OuterWrapper>
      <OuterWrapper
        sx={{
          backgroundImage: `url(${HeroBackground2})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "175px 364px",
          pb: "150px",
        }}
      >
        <InnerWrapper>
          <AboutCard />
        </InnerWrapper>
      </OuterWrapper>
    </OuterWrapper>
  );

  function AboutCard() {
    var settings = {
      arrows: false,
      speed: 5000,
      infinite: true,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 920,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };

    return (
      <Box
        component={Slider}
        {...settings}
        sx={{ px: { xs: "10px" } }}
        className="heroslider"
      >
        {aboutContentData.map((data) => {
          return (
            <Box>
              <CardIcon
                component="img"
                image={data.icon}
                alt=""
                sx={{
                  width: { xs: 90, md: 120 },
                  top: { xs: "45px", md: "65px" },
                }}
              />
              <CardBody
                sx={{
                  width: { md: "375px" },
                  height: { xs: 185, sm: 250, md: 170 },
                  pt: { xs: "40px", sm: "45px", md: "60px" },
                }}
              >
                <CardContent>
                  <CardTitle>{data.title}</CardTitle>
                  <CardSubtitle>{data.para}</CardSubtitle>
                </CardContent>
              </CardBody>
            </Box>
          );
        })}
      </Box>
    );
  }
}

export default Hero;
